import React, { Component } from 'react';
import axios from 'axios';
import './VideoRoomComponent.css';
import { OpenVidu } from 'openvidu-browser';
import StreamComponent from './stream/StreamComponent';
import OvVideoComponent from './stream/OvVideo';
import DialogExtensionComponent from './dialog-extension/DialogExtension';
import IconButton from '@material-ui/core/IconButton';
/*import ChatComponent from './chat/ChatComponent';*/

import SidebarComponent from './sidebar/SidebarComponent';

import OpenViduLayout from '../layout/openvidu-layout';
import OpenViduLayoutPortrait from '../layout/openvidu-layout-portrait';
import OpenViduLayoutPaysage from '../layout/openvidu-layout-paysage';

import UserModel from '../models/user-model';

import ToolbarComponent from './toolbar/ToolbarComponent';
import ToolbarPortraitComponent from './toolbar/ToolbarPortraitComponent';
import ToolbarLandscapeComponent from './toolbar/ToolbarLandscapeComponent';
import SettingsFABComponent from './toolbar/SettingsFABComponent';

import MultiStreamsMixer from 'multistreamsmixer_hgl';

import Popup from "reactjs-popup";
import {Container, Row, Col, Form, Input, Button} from 'reactstrap';

import socketIOClient from "socket.io-client";

import { ov_api, socket_endpoint } from '../api/apis.js'

import {
  isBrowser,
  isMobile,
  browserName,
  isMobileOnly,
  isFirefox,
  isSafari,
  isMobileSafari,
  isChrome,
} from "react-device-detect";

var localUser = new UserModel();

var localUser2 = new UserModel();

const logo = require('../assets/images/logo_nb.gif');
const listIconSVG = require('../assets/images/list-icon.svg');


class VideoRoomComponent extends Component {
    constructor(props) {
        super(props);

        this.chatInterval = null;
        this.hasBeenUpdated = false;
        if (isMobileOnly) {
          /*if ((window.orientation == 0) || (window.orientation) == 180) {
            //portrait
            this.layout = new OpenViduLayoutPortrait();
          } else {
            //paysage
            this.layout = new OpenViduLayoutPaysage();
          }*/
          this.layout = new OpenViduLayoutPortrait();
        } else {
          this.layout = new OpenViduLayout();
        }
        //let sessionName = this.props.sessionName ? this.props.sessionName : 'SessionA';
        //let userName = this.props.user ? this.props.user : 'OpenVidu_User' + Math.floor(Math.random() * 100);
        this.state = {
            mySessionId: undefined,
            myUserName: undefined,
            session: undefined,
            session2: undefined,
            localUser: undefined,
            localUser2: undefined,
            subscribers: [],
            chatDisplay: 'none',
            xPositionChat : 400,
            xPositionBounds : 0,
            askLeaveSession : false,
            screenOrientation : undefined,
            menuPortraitPopup : false,
            askRecordFile : false,
            recorderComp : undefined,
            mobileSelectVideo : undefined,
            landscapeFullScreen : true,
        };

        //this.joinSession = this.joinSession.bind(this);
        this.leaveSession = this.leaveSession.bind(this);
        this.onbefore = this.onbeforeunload.bind(this);
        this.updateLayout = this.updateLayout.bind(this);
        this.camStatusChanged = this.camStatusChanged.bind(this);
        this.micStatusChanged = this.micStatusChanged.bind(this);
        this.nicknameChanged = this.nicknameChanged.bind(this);
        this.toggleFullscreen = this.toggleFullscreen.bind(this);
        this.exitFullscreen = this.exitFullscreen.bind(this);
        this.screenShare = this.screenShare.bind(this);
        this.stopScreenShare = this.stopScreenShare.bind(this);
        this.closeDialogExtension = this.closeDialogExtension.bind(this);
        this.toggleChat = this.toggleChat.bind(this);
        this.endToggleChat = this.endToggleChat.bind(this);
        this.checkNotification = this.checkNotification.bind(this);
        this.checkSize = this.checkSize.bind(this);
        this.settingsWindows = this.settingsWindows.bind(this);
        this.invitWindows = this.invitWindows.bind(this);
        this.askLeaveSession = this.askLeaveSession.bind(this);
        this.notLeaveSession = this.notLeaveSession.bind(this);
        this.triggerCloseChat = this.triggerCloseChat.bind();
        this.openMenuPortraitPopup = this.openMenuPortraitPopup.bind(this);
        this.closeMenuPortraitPopup = this.closeMenuPortraitPopup.bind(this);

        this.downloadRecordFile = this.downloadRecordFile.bind(this);
        this.embededRecordFile = this.embededRecordFile.bind(this);
        this.notRecordFile = this.notRecordFile.bind(this);

        this.changeMobileSelectVideo = this.changeMobileSelectVideo.bind(this);
        this.switchMobileCamera = this.switchMobileCamera.bind(this);
        this.disableLandscapeFullScreen = this.disableLandscapeFullScreen.bind(this);

        this.hideMenuPaysage = this.hideMenuPaysage.bind(this);
        this.viewMenuPaysage = this.viewMenuPaysage.bind(this)
        this.clickMenuPaysage = this.clickMenuPaysage.bind(this);;


        this.actStream = this.props.actStream;

        this.mobileSelectFace = 'user';  // or 'environment'

        this.timerHideMenuPaysage = null;


        //console.log(this.props.userData);
        //console.log(this.props.userLinks);

        //console.log(this.props.streamMixer.getMixedStream());
        //console.log(this.actStream);

    }

    componentDidMount() {
      this.orientationListener();
      window.addEventListener("orientationchange", this.orientationListener);
      const openViduLayoutOptions = {
        maxRatio: 9 / 16, // The narrowest ratio that will be used (default 2x3)
        minRatio: 9 / 16, // The widest ratio that will be used (default 16x9)
        fixedRatio: true, // If this is true then the aspect ratio of the video is maintained and minRatio and maxRatio are ignored (default false)
        bigClass: 'OV_big', // The class to add to elements that should be sized bigger
        bigPercentage: 0.8, // The maximum percentage of space the big ones should take up
        bigFixedRatio: true, // fixedRatio for the big ones
        bigMaxRatio: 9 / 16, // The narrowest ratio to use for the big elements (default 2x3)
        bigMinRatio: 9 / 16, // The widest ratio to use for the big elements (default 16x9)
        bigFirst: true, // Whether to place the big one in the top left (true) or bottom right
        animate: true, // Whether you want to animate the transitions
      };


      this.layout.initLayoutContainer(document.getElementById('layout'), openViduLayoutOptions);
      window.addEventListener('beforeunload', this.onbeforeunload);
      window.addEventListener('resize', this.updateLayout);
      window.addEventListener('resize', this.checkSize);


      //console.log(this.props.tokenData[0]);

      this.socketio = socketIOClient(socket_endpoint);

      this.socketio.emit("info_user", JSON.stringify({id : this.props.userData.id, status : this.props.userData.status}));


      this.OV = new OpenVidu();
      this.OV.enableProdMode();
      this.OVScreen = new OpenVidu();
      this.OVScreen.enableProdMode();

      this.setState(
          {
              session: this.OV.initSession(),
              session2: this.OVScreen.initSession(),
          },
          () => {
              //console.log(this.props.tokenData);

              if (this.props.embededMode == "true") {
                this.connectWebCam();
              } else {
                this.connect(this.props.tokenData[0]);
                this.connectScreen(this.props.tokenData[1]);
              }


              this.subscribeToStreamCreated();
              this.subscribeToEndOfSession();

          },
      );

      if ((isMobileOnly) && (this.props.userData.status == "teacher")) {
        this.invitWindows(true);
      }

      if (isMobileOnly == true) {
        this.toggleFullscreen();
      }


    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.onbeforeunload);
        window.removeEventListener('resize', this.updateLayout);
        window.removeEventListener('resize', this.checkSize);
        window.removeEventListener("orientationchange", this.orientationListener);
        this.leaveSession();
    }

    orientationListener = () => {
      if (isMobileSafari == true) {
        document.documentElement.style.height = `initial`;
        setTimeout(() => {
          document.documentElement.style.height = `100%`;
            setTimeout(() => {
              // this line prevents the content
              // from hiding behind the address bar
              window.scrollTo(0, 1);
            }, 10);
        }, 10);
      }
      if ((window.orientation == 0) || (window.orientation) == 180) {
        this.setState({ screenOrientation: 'portait' });
        this.viewMenuPaysage();
      } else {
        this.setState({ screenOrientation: 'landscape' });
        this.hideMenuPaysage();
      }

    }

    hideMenuPaysage() {
      this.timerHideMenuPaysage = setInterval(function() {
        if (document.getElementById("container")) {
          document.getElementById("container").classList.add("hideMenuPaysage");
        }
      }.bind(this), 2000);
    }

    viewMenuPaysage() {
      console.log("viewmenupaysage");
      if (this.timerHideMenuPaysage) {
        clearTimeout(this.timerHideMenuPaysage);
      }
      if (document.getElementById("container")) {
        document.getElementById("container").classList.remove("hideMenuPaysage");
      }
    }

    clickMenuPaysage() {
      this.viewMenuPaysage();
      this.hideMenuPaysage();
    }



    onbeforeunload(e) {
      if (this.props.embededMode != "true") {
        e.preventDefault();
        var e = e || window.event;

        // For IE and Firefox
        if (e) {
          e.returnValue = 'Quitter le cours en visio ?';
        }

        // For Safari
        return 'Quitter le cours en visio ?';
        //this.leaveSession();
      }
    }

    connect(token) {
        var name = this.props.userData.firstName + " " + this.props.userData.lastName;
        this.state.session
            .connect(
                token,
                { safariStream : isSafari, userId : this.props.userData.id, userName: this.props.userData.username, status : this.props.userData.status, name: name},
            )
            .then(() => {
                //console.error(this.state.session)
                this.setState({
                    //mySessionId: this.state.session.sessionId, //TODO -> change this for student
                    mySessionId: this.props.sessionName,
                    myUserName: this.props.userData.username,
                });
                this.connectWebCam();
            })
            .catch((error) => {
                if(this.props.error){
                    this.props.error({ error: error.error, messgae: error.message, code: error.code, status: error.status });
                }
                //alert('There was an error connecting to the session:', error.message);
                this.props.errorPopup("Arglll ! Une erreur inconnue s’est produite, rafraîchissez, redémarrez… et si le problème persiste contactez nous !")
                console.log('There was an error connecting to the session:', error.code, error.message);
            });
    }

    connectScreen(token) {
        var name = this.props.userData.firstName + " " + this.props.userData.lastName;
        this.state.session2
            .connect(
                token,
                { safariStream : isSafari, userId : this.props.userData.id, userName: this.props.userData.username, status : this.props.userData.status, name: name },
            )
            .then(() => {
                //console.error(this.state.session)
                this.setState({
                    //mySessionId: this.state.session.sessionId, //TODO -> change this for student
                    mySessionId: this.props.sessionName,
                    myUserName: this.props.userData.username,
                });
                //this.connectWebCam();
            })
            .catch((error) => {
                if(this.props.error){
                    this.props.error({ error: error.error, messgae: error.message, code: error.code, status: error.status });
                }
                //alert('There was an error connecting to the session:', error.message);
                this.props.errorPopup("Arglll ! Une erreur inconnue s’est produite, rafraîchissez, redémarrez… et si le problème persiste contactez nous !")
                console.log('There was an error connecting to the session:', error.code, error.message);
            });
    }


    connectWebCam() {
      var videoStream = this.actStream.getVideoTracks()[0];
      var audioStream = this.actStream.getAudioTracks()[0];

      navigator.allMediaStreams.push(videoStream);
      navigator.allMediaStreams.push(audioStream);

      localUser.setNickname(this.props.userData.firstName + " " + this.props.userData.lastName);
      //this.sendSignalUserChanged({ nickname: this.props.userData.firstName + " " + this.props.userData.lastName });

      localUser.setVideoActive(this.props.infosDevices.activeVideo);
      localUser.setAudioActive(this.props.infosDevices.activeAudio);


      let publisher = this.OV.initPublisher(undefined, {
          audioSource: audioStream,
          videoSource: videoStream,
          publishAudio: localUser.isAudioActive(),
          publishVideo: localUser.isVideoActive(),
          resolution: '640x480',
          frameRate: 30,
          insertMode: 'APPEND'
      });

      navigator.safariPublisher = publisher;

      if (this.props.embededMode != "true") {
        if (this.state.session.capabilities.publish) {
            this.state.session.publish(publisher).then(() => {
              console.log("publish ok");
              console.log(this);
              this.setState({ localUser: localUser });
            });
        }

        localUser.setConnectionId(this.state.session.connection.connectionId);
      }



      localUser.setScreenShareActive(false);
      localUser.setStreamManager(publisher);
      if (isSafari) {
        localUser.setSafariStream(true);
      }

      if (this.props.embededMode != "true") {
        this.subscribeToUserChanged();
        this.subscribeToStreamDestroyed();
        this.sendSignalUserChanged({ isScreenShareActive: localUser.isScreenShareActive() });

        if (isMobileOnly) {
          sessionStorage.setItem('chatMsgs', JSON.stringify([]));
          localUser.getStreamManager().stream.session.on('signal:chat', (event) => {
            var storageMsgs = JSON.parse(sessionStorage.getItem('chatMsgs'));
            const data = JSON.parse(event.data);
            let messageList = this.state.messageList;
            var avatar = "data:image/svg+xml;base64,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";
            /*if (data.avatar != "") {
              avatar = data.avatar;
            }*/
            storageMsgs.push({ timestamp : data.timestamp, avatar : avatar, connectionId: event.from.connectionId, nickname: data.nickname, message: data.message });
            sessionStorage.setItem('chatMsgs', JSON.stringify(storageMsgs));
            this.checkNotification();
          });
        }

        if (isMobileOnly) {
          this.setState({ mobileSelectVideo : localUser, localUser: localUser }, () => {
              this.state.localUser.getStreamManager().on('streamPlaying', (e) => {
                  this.updateLayout();
                  publisher.videos[0].video.parentElement.classList.remove('custom-class');
              });
          });
        } else {
          this.setState({ localUser: localUser }, () => {
              this.state.localUser.getStreamManager().on('streamPlaying', (e) => {
                  this.updateLayout();
                  publisher.videos[0].video.parentElement.classList.remove('custom-class');
              });
          });
        }

      } else {
        localUser.getStreamManager().stream.streamId = "Pedagotech-Record"
        this.setState({ localUser: localUser }, () => {
          this.updateLayout();
          publisher.videos[0].video.parentElement.classList.remove('custom-class');
          var _this = this;
          setTimeout(function() {
            _this.updateLayout();
          }, 100);
          setTimeout(function() {
            _this.updateLayout();
          }, 500);
        });
      }

    }

    askLeaveSession() {
      if (this.state.askLeaveSession == false) {
        this.setState({ askLeaveSession: true });
      } else {
        this.setState({ askLeaveSession: false });
      }
    }

    notLeaveSession() {
      this.setState({ askLeaveSession: false });
      this.refs.ToolbarComponent.notLeaveSession();
    }

    leaveSession() {
        this.exitFullscreen();
        sessionStorage.clear();

        const mySession = this.state.session;
        const mySession2 = this.state.session2;

        if (mySession) {
            this.socketio.disconnect();

            mySession.disconnect();

        }

        if (mySession2) {

            mySession2.disconnect();

        }

        // Empty all properties...
        this.OV = null;
        this.OVScreen = null;
        this.setState({
            session: undefined,
            session2: undefined,
            subscribers: [],
            mySessionId: undefined,
            myUserName: undefined,
            localUser: undefined,
            localUser2: undefined,
        });
        if (this.props.leaveSession) {
            this.props.leaveSession();
        }

        if (this.props.streamMixer) {
          this.props.streamMixer.releaseStreams();
        }

        /*this.actStream.getVideoTracks().forEach(function(track) {
          //console.log(video);
          track.stop();
        });
        this.actStream.getAudioTracks().forEach(function(track) {
          //console.log(video);
          track.stop();
        });
        this.actStream.stop();*/

        console.log(navigator.allMediaStreams);
        navigator.allMediaStreams.forEach(function (stream) {
          if (stream.kind == "video") {
            stream.stop();
          } else if (stream.kind == "audio") {
            stream.stop()
          } else {
            stream.getAudioTracks().forEach(function (track) {
              track.stop();
            });
            stream.getVideoTracks().forEach(function (track) {
              track.stop();
            });
          }
        });

        this.props.close()


        //this.props.streamMixer.getMixedStream().stop();

        //console.log(this.props.streamMixer.getMixedStream());
        //console.log(this.actStream);



        //this.actStream.stop();


        //console.warn("session leaved");
    }
    camStatusChanged() {
        localUser.setVideoActive(!localUser.isVideoActive());
        localUser.getStreamManager().publishVideo(localUser.isVideoActive());
        this.sendSignalUserChanged({ isVideoActive: localUser.isVideoActive() });
        this.setState({ localUser: localUser });
    }

    micStatusChanged() {
        localUser.setAudioActive(!localUser.isAudioActive());
        localUser.getStreamManager().publishAudio(localUser.isAudioActive());
        this.sendSignalUserChanged({ isAudioActive: localUser.isAudioActive() });
        this.setState({ localUser: localUser });
    }

    nicknameChanged(nickname) {
        let localUser = this.state.localUser;
        localUser.setNickname(nickname);
        this.setState({ localUser: localUser });
        this.sendSignalUserChanged({ nickname: this.state.localUser.getNickname() });
    }

    deleteSubscriber(stream) {
        const remoteUsers = this.state.subscribers;
        const userStream = remoteUsers.filter((user) => user.getStreamManager().stream === stream)[0];
        if (isMobileOnly) {
          if (userStream.connectionId == this.state.mobileSelectVideo.connectionId) {
            //console.log("change mobileSelectVideo")
            this.setState({
                mobileSelectVideo: localUser,
            });
          }
        }
        let index = remoteUsers.indexOf(userStream, 0);
        if (index > -1) {
            remoteUsers.splice(index, 1);
            this.setState({
                subscribers: remoteUsers,
            });
        }
    }

    subscribeToStreamCreated() {
        this.state.session.on('streamCreated', (event) => {
          //console.log(event);
          var remoteUserId = JSON.parse(event.stream.connection.data).userId;
            if (remoteUserId != this.props.userData.id) {
              console.log(event);
              const subscriber = this.state.session.subscribe(event.stream, undefined);
              var subscribers = this.state.subscribers;
              subscriber.on('streamPlaying', (e) => {
                  this.checkSomeoneShareScreen();
                  subscriber.videos[0].video.parentElement.classList.remove('custom-class');
              });
              const newUser = new UserModel();
              newUser.setStreamManager(subscriber);
              newUser.setConnectionId(event.stream.connection.connectionId);
              newUser.setType('remote');
              const nickname = JSON.parse(event.stream.connection.data).name;
              newUser.setNickname(nickname);
              //console.log(JSON.parse(event.stream.connection.data).safariStream);
              newUser.setSafariStream(JSON.parse(event.stream.connection.data).safariStream);
              subscribers.push(newUser);
              this.setState(
                  {
                      subscribers: subscribers,
                  },
                  () => {
                      if (this.state.localUser) {
                          this.sendSignalUserChanged({
                              isAudioActive: this.state.localUser.isAudioActive(),
                              isVideoActive: this.state.localUser.isVideoActive(),
                              nickname: this.state.localUser.getNickname(),
                              isScreenShareActive: this.state.localUser.isScreenShareActive(),
                          });
                      }
                      this.updateLayout();
                  },
              );
            }
        });
    }

    subscribeToEndOfSession() {
      this.state.session.on('sessionDisconnected', (event) => {
        //console.log("disconnect event :")
        //console.log(event.reason);
        if ((event.reason == "sessionClosedByServer") && (this.props.userData.status == "student")) {
          this.leaveSession();
        }
      });
    }

    subscribeToStreamDestroyed() {
        // On every Stream destroyed...
        this.state.session.on('streamDestroyed', (event) => {
            // Remove the stream from 'subscribers' array
            this.deleteSubscriber(event.stream);
            setTimeout(() => {
                this.checkSomeoneShareScreen();
            }, 20);
            event.preventDefault();
            this.updateLayout();
        });
    }

    subscribeToUserChanged() {
        this.state.session.on('signal:userChanged', (event) => {
            let remoteUsers = this.state.subscribers;
            remoteUsers.forEach((user) => {
                if (user.getConnectionId() === event.from.connectionId) {
                    const data = JSON.parse(event.data);
                    //console.log('EVENTO REMOTE: ', event.data);
                    if (data.isAudioActive !== undefined) {
                        user.setAudioActive(data.isAudioActive);
                    }
                    if (data.isVideoActive !== undefined) {
                        user.setVideoActive(data.isVideoActive);
                    }
                    if (data.nickname !== undefined) {
                        user.setNickname(data.nickname);
                    }
                    if (data.isScreenShareActive !== undefined) {
                        user.setScreenShareActive(data.isScreenShareActive);
                    }
                }
            });
            this.setState(
                {
                    subscribers: remoteUsers,
                },
                () => this.checkSomeoneShareScreen(),
            );
        });
    }

    updateLayout() {
        setTimeout(() => {
            this.layout.updateLayout();
        }, 20);
    }

    sendSignalUserChanged(data) {
        const signalOptions = {
            data: JSON.stringify(data),
            type: 'userChanged',
        };
        this.state.session.signal(signalOptions);
    }

    toggleFullscreen() {
        const document = window.document;
        if (document) {
        //const fs = document.getElementById('container');
          const fs = document.body;
          if (
              !document.fullscreenElement &&
              !document.mozFullScreenElement &&
              !document.webkitFullscreenElement &&
              !document.msFullscreenElement
          ) {
              if (fs.requestFullscreen) {
                  fs.requestFullscreen();
              } else if (fs.msRequestFullscreen) {
                  fs.msRequestFullscreen();
              } else if (fs.mozRequestFullScreen) {
                  fs.mozRequestFullScreen();
              } else if (fs.webkitRequestFullscreen) {
                  fs.webkitRequestFullscreen();
              }
          } else {
              if (document.exitFullscreen) {
                  document.exitFullscreen();
              } else if (document.msExitFullscreen) {
                  document.msExitFullscreen();
              } else if (document.mozCancelFullScreen) {
                  document.mozCancelFullScreen();
              } else if (document.webkitExitFullscreen) {
                  document.webkitExitFullscreen();
              }
          }
        }
    }

    exitFullscreen() {
        const document = window.document;
        if (document) {
          const fs = document.body;
          if (
              !document.fullscreenElement &&
              !document.mozFullScreenElement &&
              !document.webkitFullscreenElement &&
              !document.msFullscreenElement
          ) { } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
          }
        }
    }

    screenShare() {
      if ((localUser2.getStreamManager() != null) || (localUser2.getStreamManager() != undefined)) {
        var displayMediaStreamConstraints = {
            video: true,
            audio : false
        };

        if (navigator.mediaDevices.getDisplayMedia) {
            navigator.mediaDevices.getDisplayMedia(displayMediaStreamConstraints).then(function(screenStream) {
              //console.log(screenStream);
              localUser2.getStreamManager().replaceTrack(screenStream.getVideoTracks()[0]);
            }).catch(function(error) {

              console.log(error);
            });
        } else {
            navigator.getDisplayMedia(displayMediaStreamConstraints).then(function(screenStream) {
              //console.log(screenStream);
              localUser2.getStreamManager().replaceTrack(screenStream.getVideoTracks()[0]);
            }).catch(function(error) {
              console.log(error);
            });
        }
      } else {
        if ((isBrowser == true) && (isChrome == true)) {
          var displayMediaStreamConstraints = {
              video: true,
              audio : true
          };
          var _this = this;
          if (navigator.mediaDevices.getDisplayMedia) {
              navigator.mediaDevices.getDisplayMedia(displayMediaStreamConstraints).then(function(screenStream) {
                //console.log(screenStream.getVideoTracks()[0]);
                //console.log(screenStream.getAudioTracks());
                //console.log("1");
                var publish_audio = false;
                /*if (screenStream.getVideoTracks()[0].getSettings().displaySurface == "monitor") {
                  publish_audio = false;
                }*/
                if (screenStream.getAudioTracks().length != 0) {
                  publish_audio = true;
                }
                if (publish_audio == true) {
                  var params_publisher = {
                    audioSource : screenStream.getAudioTracks()[0],
                    videoSource : screenStream.getVideoTracks()[0],
                    publishAudio: true,
                    publishVideo: true,
                    mirror: false
                  }
                } else {
                  var params_publisher = {
                    audioSource : null,
                    videoSource : screenStream.getVideoTracks()[0],
                    publishAudio: false,
                    publishVideo: true,
                    mirror: false
                  }
                }
                //console.log("publish_audio 1 : "+publish_audio);
                const publisher = _this.OVScreen.initPublisher(
                    undefined,
                    params_publisher,
                    (error) => {
                        if (error && error.name === 'SCREEN_EXTENSION_NOT_INSTALLED') {
                            _this.setState({ showExtensionDialog: true });
                        } else if (error && error.name === 'SCREEN_SHARING_NOT_SUPPORTED') {
                            alert("Votre navigateur ne prend pas en charge le partage d'écran");
                        } else if (error && error.name === 'SCREEN_EXTENSION_DISABLED') {
                            //alert('You need to enable screen sharing extension');
                        } else if (error && error.name === 'SCREEN_CAPTURE_DENIED') {
                            //alert('Vous devez choisir une fenêtre ou une application à partager');
                        }
                    },
                );

                publisher.once('accessAllowed', () => {
                    localUser2.setNickname(_this.state.myUserName);
                    localUser2.setStreamManager(publisher);
                    _this.state.session2.publish(publisher).then(() => {
                      //console.log("scrren publish in session 2");
                      localUser2.setScreenShareActive(true);

                      _this.setState({ localUser2: localUser2});
                    });
                });
                publisher.on('streamPlaying', () => {
                    _this.updateLayout();
                    publisher.videos[0].video.parentElement.classList.remove('custom-class');
                    publisher.stream.getMediaStream().getVideoTracks()[0].addEventListener('ended', () => {
                      _this.stopScreenShare();
                    });
                });
              }).catch(function(error) {
                console.log(error);
              });
          } else {
              navigator.getDisplayMedia(displayMediaStreamConstraints).then(function(screenStream) {
                //console.log(screenStream);
                //console.log("2");
                var publish_audio = false;
                /*if (screenStream.getVideoTracks()[0].getSettings().displaySurface == "monitor") {
                  publish_audio = false;
                }*/
                if (screenStream.getAudioTracks().length != 0) {
                  publish_audio = true;
                }
                if (publish_audio == true) {
                  var params_publisher = {
                    audioSource : screenStream.getAudioTracks()[0],
                    videoSource : screenStream.getVideoTracks()[0],
                    publishAudio: true,
                    publishVideo: true,
                    mirror: false
                  }
                } else {
                  var params_publisher = {
                    audioSource : null,
                    videoSource : screenStream.getVideoTracks()[0],
                    publishAudio: false,
                    publishVideo: true,
                    mirror: false
                  }
                }
                //console.log("publish_audio 2 : "+publish_audio);
                const publisher = _this.OVScreen.initPublisher(
                    undefined,
                    params_publisher,
                    (error) => {
                        if (error && error.name === 'SCREEN_EXTENSION_NOT_INSTALLED') {
                            _this.setState({ showExtensionDialog: true });
                        } else if (error && error.name === 'SCREEN_SHARING_NOT_SUPPORTED') {
                            alert("Votre navigateur ne prend pas en charge le partage d'écran");
                        } else if (error && error.name === 'SCREEN_EXTENSION_DISABLED') {
                            //alert('You need to enable screen sharing extension');
                        } else if (error && error.name === 'SCREEN_CAPTURE_DENIED') {
                            //alert('Vous devez choisir une fenêtre ou une application à partager');
                        }
                    },
                );

                publisher.once('accessAllowed', () => {
                    localUser2.setNickname(_this.state.myUserName);
                    localUser2.setStreamManager(publisher);
                    _this.state.session2.publish(publisher).then(() => {
                      //console.log("scrren publish in session 2");
                      localUser2.setScreenShareActive(true);

                      _this.setState({ localUser2: localUser2});
                    });
                });
                publisher.on('streamPlaying', () => {
                    _this.updateLayout();
                    publisher.videos[0].video.parentElement.classList.remove('custom-class');
                    publisher.stream.getMediaStream().getVideoTracks()[0].addEventListener('ended', () => {
                      _this.stopScreenShare();
                    });
                });
              }).catch(function(error) {
                console.log(error);
              });
          }
        } else {
          /*var videoSource = 'window';
          if (isFirefox) {
            videoSource = 'screen';
          }*/
          var videoSource = 'screen';
          console.log("new screen sharing");
          console.log(videoSource);
          const publisher = this.OVScreen.initPublisher(
              undefined,
              {
                  //videoSource: videoSource,
                  videoSource : videoSource,
                  publishAudio: false,
                  publishVideo: true,
                  mirror: false,
              },
              (error) => {
                  if (error && error.name === 'SCREEN_EXTENSION_NOT_INSTALLED') {
                      this.setState({ showExtensionDialog: true });
                  } else if (error && error.name === 'SCREEN_SHARING_NOT_SUPPORTED') {
                      alert("Votre navigateur ne prend pas en charge le partage d'écran");
                  } else if (error && error.name === 'SCREEN_EXTENSION_DISABLED') {
                      //alert('You need to enable screen sharing extension');
                  } else if (error && error.name === 'SCREEN_CAPTURE_DENIED') {
                      //alert('Vous devez choisir une fenêtre ou une application à partager');
                  }
              },
          );

          publisher.once('accessAllowed', () => {
              localUser2.setNickname(this.state.myUserName);
              localUser2.setStreamManager(publisher);
              this.state.session2.publish(publisher).then(() => {
                //console.log("scrren publish in session 2");
                localUser2.setScreenShareActive(true);

                this.setState({ localUser2: localUser2});
              });
          });
          publisher.on('streamPlaying', () => {
              this.updateLayout();
              publisher.videos[0].video.parentElement.classList.remove('custom-class');
              publisher.stream.getMediaStream().getVideoTracks()[0].addEventListener('ended', () => {
                this.stopScreenShare();
              });
          });
        }


      }
    }

    closeDialogExtension() {
        this.setState({ showExtensionDialog: false });
    }

    stopScreenShare() {
        this.state.session2.unpublish(localUser2.getStreamManager());
        localUser2.setScreenShareActive(false);
        localUser2.setStreamManager(null);
        this.setState({ localUser2: localUser2});
        //this.connectWebCam();
    }

    checkSomeoneShareScreen() {
        let isScreenShared;
        // return true if at least one passes the test
        isScreenShared = this.state.subscribers.some((user) => user.isScreenShareActive()) || localUser.isScreenShareActive();
        const openviduLayoutOptions = {
            maxRatio: 3 / 2,
            minRatio: 9 / 16,
            fixedRatio: isScreenShared,
            bigClass: 'OV_big',
            bigPercentage: 0.8,
            bigFixedRatio: false,
            bigMaxRatio: 3 / 2,
            bigMinRatio: 9 / 16,
            bigFirst: true,
            animate: true,
        };
        this.layout.setLayoutOptions(openviduLayoutOptions);
        this.updateLayout();
    }

    toggleChat(property) {
        clearInterval(this.chatInterval);
        this.chatInterval = null;
        if (this.state.xPositionChat == 0) {
          if (isMobileOnly) {
            this.setState({
              xPositionChat: 400,
              messageReceived : false,
              menuPortraitPopup : false
            });
          } else {
            this.setState({
              xPositionChat: 400,
              xPositionBounds: 0,
              messageReceived : false
            });
          }

        } else {
          if (isMobileOnly) {
            this.setState({
              xPositionChat: 0,
              messageReceived : false,
              menuPortraitPopup : false
            });
          } else {
            this.setState({
              xPositionChat: 0,
              xPositionBounds: 400,
              messageReceived : false
            });
            this.refs.Sidebar.scrollToBottom();
          }
        }
        var _this = this;
        this.chatInterval =  setInterval(function() {
          _this.updateLayout();
        }, 100);
    }

    endToggleChat() {
      clearInterval(this.chatInterval);
      this.chatInterval = null;
      this.updateLayout();
    }

    checkNotification() {
        console.log("check notification");
        if (this.state.xPositionChat == 0) {
          this.setState({
              messageReceived : false
          });
        } else {
          this.setState({
              messageReceived : true
          });
        }
    }

    checkSize() {
        if (document.getElementById('layout')) {
          if (document.getElementById('layout').offsetWidth <= 700 && !this.hasBeenUpdated) {
              //this.toggleChat('none');
              this.hasBeenUpdated = true;
          }
          if (document.getElementById('layout').offsetWidth > 700 && this.hasBeenUpdated) {
              this.hasBeenUpdated = false;
          }
        }
    }

    settingsWindows(data) {
      var data2 = {data: data, streamMixer: this.props.streamMixer, actStream : this.actStream};
      this.props.settingsWindows(data2);
      this.closeMenuPortraitPopup();
    }

    invitWindows(data) {
      var data2 = {data: data};
      this.props.invitWindows(data2);
      this.closeMenuPortraitPopup();
    }

    triggerCloseConfig() {
      if (this.props.embededMode == "true") {
        this.refs.SettingsFABComponent.triggerCloseConfig();
      } else {
        if (isMobileOnly == false) {
          this.refs.ToolbarComponent.triggerCloseConfig();
        }
      }
    }

    triggerCloseInvit() {
      if (isMobileOnly == false) {
        this.refs.ToolbarComponent.triggerCloseInvit();
      }
    }

    triggerCloseChat(that) {
      //console.log(that);
      that.toggleChat();
      that.refs.ToolbarComponent.triggerCloseChat();
    }

    openMenuPortraitPopup() {
      //console.log("openMenuPortraitPopup")
      this.setState({menuPortraitPopup : true});
    }

    closeMenuPortraitPopup() {
      //console.log("closeMenuPortraitPopup")
      this.setState({menuPortraitPopup : false });
    }

    askRecordFile(recorderComp) {
      this.setState({
        askRecordFile : true,
        recorderComp : recorderComp,
      });
    }

    downloadRecordFile() {
      this.state.recorderComp.download();
      this.state.recorderComp.clean();
      this.setState({
        askRecordFile : false,
        recorderComp : undefined,
      });
    }

    embededRecordFile() {
      var fr = new FileReader();
      fr.onload = function(event) {
        try{
          window.parent.postMessage(event.target.result, "*")
        } catch(err) {

        }
      };
      fr.readAsArrayBuffer(this.state.recorderComp.getBlob());

      this.state.recorderComp.clean();
      this.setState({
        askRecordFile : false,
        recorderComp : undefined,
      });
    }

    notRecordFile() {
      this.state.recorderComp.clean();
      this.setState({
        askRecordFile : false,
        recorderComp : undefined,
      });
    }

    changeMobileSelectVideo(user) {
      if (this.state.screenOrientation == "landscape") {
        this.hideMenuPaysage();
        this.setState({
          mobileSelectVideo: user,
          landscapeFullScreen : true,
        }, this.updateLayout);
        var _this = this;
        setTimeout(function() {
          _this.updateLayout();
        }, 50);
      } else {
        this.setState({
          mobileSelectVideo: user,
        }, this.updateLayout);
        var _this = this;
        setTimeout(function() {
          _this.updateLayout();
        }, 50);
      }
    }

    switchMobileCamera() {
      var _this = this;
      console.log("switchMobileCamera");
      if (!navigator.mediaDevices.getSupportedConstraints().facingMode) {
          this.props.infoPopup("Fonctionnalité non supportée");
      } else {
          //supported
          if (isSafari) {
            this.props.infoPopup("Fonctionnalité non supportée");
          } else {

            if (this.mobileSelectFace == 'user') {
              this.mobileSelectFace = 'environment';
            } else {
              this.mobileSelectFace = 'user';
            }

            var constraints_audio = {
              video : false,
              audio : {
                deviceId: { exact : navigator.infosDevices.selectAudio.value }
              },
            };
            if (navigator.audioStream) {
              navigator.audioStream.getAudioTracks().forEach(function (track) {
                track.stop();
              });
              navigator.audioStream.getVideoTracks().forEach(function (track) {
                track.stop();
              });
              delete navigator.audioStream;
            }
            navigator.mediaDevices.getUserMedia(constraints_audio).then(function(audioStream) {
              navigator.allMediaStreams.push(audioStream);
              navigator.audioStream = audioStream;

              //first camera
              var constraints = {
                video : {facingMode: {exact: _this.mobileSelectFace}},
                audio : false,
              };
              if (navigator.cam1) {
                navigator.cam1.getAudioTracks().forEach(function (track) {
                  track.stop();
                });
                navigator.cam1.getVideoTracks().forEach(function (track) {
                  track.stop();
                });
                delete navigator.cam1;
              }
              navigator.mediaDevices.getUserMedia(constraints).then(function(cam1) {
                navigator.allMediaStreams.push(cam1);
                navigator.cam1 = cam1;

                var streamWidth = 640;
                var streamHeight = 360;

                if (_this.props.streamMixer) {
                  //_this.streamMixer.releaseStreams();
                  var paras = document.getElementsByClassName('multi-streams-mixer');
                  while(paras[0]) {
                      paras[0].parentNode.removeChild(paras[0]);
                  }
                }

                cam1.fullcanvas = true;
                cam1.width = streamWidth;
                cam1.height = streamHeight;

                _this.props.streamMixer.resetVideoStreams([cam1, audioStream]);

                //get deviceID
                navigator.switchCameraDevice = cam1.getVideoTracks()[0].getSettings().deviceId;
              });

            });

          }
      }
    }

    disableLandscapeFullScreen() {
      //console.log("disableLandscapeFullScreen");
      this.setState({ landscapeFullScreen: false });
      this.viewMenuPaysage();
    }



    render() {
      const mySessionId = this.state.mySessionId;
      const localUser = this.state.localUser;
      const localUser2 = this.state.localUser2;
      var chatDisplay = { display: this.state.chatDisplay };


      var layoutClassName = "bounds";
      var endPopupClassName = "endPopup";
      var recordPopupClassName = "recordPopup";
      if (isMobileOnly) {
        if (this.state.screenOrientation == 'landscape') {
          layoutClassName = "bounds-paysage";
          endPopupClassName = "endPopup-paysage";
          recordPopupClassName = "recordPopup-paysage";
        } else {
          layoutClassName = "bounds-portrait";
          endPopupClassName = "endPopup-portrait";
          recordPopupClassName = "recordPopup-portrait";
        }
      }

      return (
        <div className="container" id="container">

          {this.state.menuPortraitPopup == true ? (
            <Popup className="menuPortraitPopup" onClose={this.closeMenuPortraitPopup} open={true} closeOnDocumentClick={true} closeOnEscape={true} modal position="right center">
              <div className={this.state.screenOrientation == 'landscape' ? "menuPopup-landscape" : null}>
                <div className="menuPortraitPopupCarre">
                  <div className="menuPortraitPopupContent" onClick={() => this.settingsWindows(true)}>
                    <IconButton color="inherit" className={isMobileSafari == true ? "navButtonMenuPortrait navButtonMenuPortraitSafariIos" : "navButtonMenuPortrait"}>
                        <span className="icon-Settings-icon"></span>
                    </IconButton>
                    <div>
                      Réglages
                    </div>
                  </div>
                </div>
                {this.props.userData.status == "teacher" ? (
                  <div className={this.state.screenOrientation == 'landscape' ? "menuPortraitPopupCarre menuPortraitPopupCarreCentral-landscape" : "menuPortraitPopupCarre menuPortraitPopupCarreCentral"}>
                    <div className="menuPortraitPopupContent" onClick={() => this.invitWindows(true)}>
                      <IconButton color="inherit" className={isMobileSafari == true ? "navButtonMenuPortrait navButtonMenuPortraitSafariIos" : "navButtonMenuPortrait"}>
                          <span className="icon-Invite-icon"></span>
                      </IconButton>
                      <div>
                        Inviter des<br/>élèves
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={{height: this.state.screenOrientation == 'landscape' ? '0px': '15px', width: this.state.screenOrientation != 'landscape' ? '0px': '15px'}}>
                  </div>
                ) }
                <div className="menuPortraitPopupCarre">
                  <div className="menuPortraitPopupContent" onClick={this.toggleChat}>
                    <IconButton color="inherit" className={isMobileSafari == true ? "navButtonMenuPortrait navButtonMenuPortraitSafariIos" : "navButtonMenuPortrait"}>
                      {this.state.messageReceived && <div id="pointMenuPortrait" className="" />}
                      <span className="icon-Chat-icon"></span>
                    </IconButton>
                    <div>
                      Conversation<br/>du cours
                    </div>
                  </div>
                </div>
              </div>
            </Popup>
          ) : null}

          {isMobileOnly == true && this.state.screenOrientation != 'landscape' ? (
            <div className="blackBackground-portrait"></div>
          ) : null}

          {this.props.embededMode != "true" &&
            <>
              {isMobileOnly == true && this.state.screenOrientation == 'landscape' && this.state.landscapeFullScreen == true ? (
                <div id="navSessionList">
                  <img
                    id="header_img"
                    alt="Pedagotech Visio"
                    src={listIconSVG}
                    style={{height:'18px',width:'30px'}}
                    onClick={this.disableLandscapeFullScreen}
                  />
                </div>
              ) : (
                <div id="navSessionInfo">
                  <img
                    id="header_img"
                    alt="Pedagotech Visio"
                    src={logo}
                    style={{height:'103px',width:'89px'}}
                  />
                </div>
              )}
            </>
          }

          {this.props.embededMode == "true" &&
            <SettingsFABComponent
              ref="SettingsFABComponent"
              user={localUser}
              settingsWindows={this.settingsWindows}
            />
          }

          {(isMobileOnly == false && this.props.embededMode != "true") ? (
            <ToolbarComponent
              ref="ToolbarComponent"
              sessionId={mySessionId}
              user={localUser}
              user2={localUser2}
              userData = {this.props.userData}
              showNotification={this.state.messageReceived}
              camStatusChanged={this.camStatusChanged}
              micStatusChanged={this.micStatusChanged}
              screenShare={this.screenShare}
              stopScreenShare={this.stopScreenShare}
              toggleFullscreen={this.toggleFullscreen}
              leaveSession={this.askLeaveSession}
              toggleChat={this.toggleChat}
              settingsWindows={this.settingsWindows}
              invitWindows={this.invitWindows}
            />
          ) : null }

          {isMobileOnly == true && this.state.screenOrientation != 'landscape' ? (
            <>
              <div className="TopMenuPortrait">
                <IconButton color="inherit" id="fsMobileBtn" onClick={this.toggleFullscreen} className="topButton">
                  <span className="icon-Fullscreen-fullscreen"></span>
                </IconButton>
                <IconButton color="inherit" id="switchCameraBtn" onClick={this.switchMobileCamera} className="topButton">
                  <span className="icon-icon-switch-camera"></span>
                </IconButton>
                <IconButton color="inherit" id="mobileMenuBtn" onClick={this.openMenuPortraitPopup} className="topButton">
                  {this.state.messageReceived && <div id="pointTopMenu" className="" />}
                  <span className="icon-Hamburger"></span>
                </IconButton>
              </div>
              <ToolbarPortraitComponent
                ref="ToolbarComponent"
                sessionId={mySessionId}
                user={localUser}
                user2={localUser2}
                userData = {this.props.userData}
                showNotification={this.state.messageReceived}
                camStatusChanged={this.camStatusChanged}
                micStatusChanged={this.micStatusChanged}
                leaveSession={this.askLeaveSession}
              />
              {this.state.xPositionChat == 0 ? (
                <Popup className="conversPopup-portrait" open={true} closeOnDocumentClick={false} closeOnEscape={false} modal position="right center">
                  <SidebarComponent
                    ref = "SidebarMobile"
                    userData = {this.props.userData}
                    xPosition={0}
                    user={localUser}
                    close={() => this.triggerCloseChat(this)}
                    messageReceived={this.checkNotification}
                  />
                </Popup>
              ) : null }
            </>
          ) : null }

          {isMobileOnly == true && this.state.screenOrientation == 'landscape' ? (
            <>
              <div className="TopMenuPaysage">
                <IconButton color="inherit" id="fsMobileBtn" onClick={this.toggleFullscreen} className="topButton">
                  <span className="icon-Fullscreen-fullscreen"></span>
                </IconButton>
                <IconButton color="inherit" id="switchCameraBtn" onClick={this.switchMobileCamera} className="topButton">
                  <span className="icon-icon-switch-camera"></span>
                </IconButton>
                <IconButton color="inherit" id="mobileMenuBtn" onClick={this.openMenuPortraitPopup} className="topButton">
                  {this.state.messageReceived && <div id="point" className="" />}
                  <span className="icon-Hamburger"></span>
                </IconButton>
              </div>
              <ToolbarLandscapeComponent
                ref="ToolbarComponent"
                sessionId={mySessionId}
                user={localUser}
                user2={localUser2}
                userData = {this.props.userData}
                showNotification={this.state.messageReceived}
                camStatusChanged={this.camStatusChanged}
                micStatusChanged={this.micStatusChanged}
                leaveSession={this.askLeaveSession}
              />
              {this.state.xPositionChat == 0 ? (
                <Popup className="conversPopup-portrait" open={true} closeOnDocumentClick={false} closeOnEscape={false} modal position="right center">
                  <SidebarComponent
                    ref = "SidebarMobile"
                    userData = {this.props.userData}
                    xPosition={0}
                    user={localUser}
                    close={() => this.triggerCloseChat(this)}
                    messageReceived={this.checkNotification}
                  />
                </Popup>
              ) : null }
            </>
          ) : null }

          <DialogExtensionComponent showDialog={this.state.showExtensionDialog} cancelClicked={this.closeDialogExtension} />

          {isMobileOnly == true ? (
            <div id="layout" onClick={this.state.screenOrientation == 'landscape' && this.state.landscapeFullScreen == true ? this.clickMenuPaysage : undefined} onTransitionEnd={this.endToggleChat} className={layoutClassName} style={{display: this.state.landscapeFullScreen == false && this.state.screenOrientation == 'landscape' ? "none": "", width: "calc(100% - "+(this.state.xPositionBounds)+"px)"}}>
                {this.state.localUser !== undefined && localUser.getStreamManager().stream.streamId !== undefined && (
                    <div style={{ display: this.state.mobileSelectVideo == localUser? 'block': 'none'}} safaristreamcorrection={localUser.getSafariStream().toString()} className="OT_root OT_publisher custom-class" id="localUser">
                        <StreamComponent askRecordFile={(rec) => this.askRecordFile(rec)} streamMixer={this.props.streamMixer} actStream={this.actStream} infosDevices={this.props.infosDevices} user={localUser} handleNickname={this.nicknameChanged} hgl_layout={this.layout}/>
                    </div>
                )}
                {this.state.subscribers.map((sub, i) => (
                    <div style={{ display: this.state.mobileSelectVideo == sub? 'block': 'none'}} safaristreamcorrection={sub.getSafariStream().toString()} key={i} className="OT_root OT_publisher custom-class" id="remoteUsers">
                        <StreamComponent user={sub} streamId={sub.streamManager.stream.streamId} hgl_layout={this.layout}/>
                    </div>
                ))}
            </div>
          ) : null}
          {isMobileOnly == false ? (
            <div id="layout" onTransitionEnd={this.endToggleChat} className={layoutClassName} style={{bottom: this.props.embededMode == 'true' ? "0px": "80x", width: "calc(100% - "+(this.state.xPositionBounds)+"px)"}}>
                {localUser !== undefined && localUser.getStreamManager().stream.streamId !== undefined && (
                    <div safaristreamcorrection={localUser.getSafariStream().toString()} className="OT_root OT_publisher custom-class" id="localUser">
                        <StreamComponent embededMode={this.props.embededMode} askRecordFile={(rec) => this.askRecordFile(rec)} streamMixer={this.props.streamMixer} actStream={this.actStream} infosDevices={this.props.infosDevices} user={localUser} handleNickname={this.nicknameChanged} hgl_layout={this.layout}/>
                    </div>
                )}
                {localUser2 !== undefined && localUser2.getStreamManager() !== null && localUser2.getStreamManager().stream.streamId !== undefined && (
                    <div className="OT_root OT_publisher custom-class" id="localUser">
                        <StreamComponent screenShare={true} user={localUser2} handleNickname={this.nicknameChanged} hgl_layout={this.layout}/>
                    </div>
                )}
                {this.state.subscribers.map((sub, i) => (
                    <div safaristreamcorrection={sub.getSafariStream().toString()} key={i} className="OT_root OT_publisher custom-class" id="remoteUsers">
                        <StreamComponent user={sub} streamId={sub.streamManager.stream.streamId} hgl_layout={this.layout}/>
                    </div>
                ))}
            </div>
          ) : null}

          {isMobileOnly == true ? (
            <div className="landscapeList" style={{display: this.state.screenOrientation == 'landscape' && this.state.landscapeFullScreen == false ? 'block': 'none'}}>

              <div className="landscapeListWrapper">
                {localUser !== undefined && localUser.getStreamManager().stream.streamId !== undefined && (
                  <div onClick={() => this.changeMobileSelectVideo(localUser)} className="landscapeListLink">
                    <OvVideoComponent user={localUser} mutedSound={true} />
                  </div>
                )}
                {this.state.subscribers.map((sub, i) => (
                  <div onClick={() => this.changeMobileSelectVideo(sub)} key={i} className="landscapeListLink">
                    <OvVideoComponent user={sub} mutedSound={true} />
                  </div>
                ))}
              </div>
            </div>
          ) : null}

          {isMobileOnly == true ? (
            <div className="pn-ProductNav_Wrapper" style={{display: this.state.screenOrientation != 'landscape' ? 'block': 'none'}}>
              <nav id="pnProductNav" className="pn-ProductNav dragscroll">
                <div id="pnProductNavContents" className="pn-ProductNav_Contents pn-ProductNav_Contents-no-transition">
                  {localUser !== undefined && localUser.getStreamManager().stream.streamId !== undefined && (
                    <div className="pn-ProductNav_Link" style={{ opacity: this.state.mobileSelectVideo == localUser? '1': '0.3'}}>
                      <div onClick={() => this.changeMobileSelectVideo(localUser)}>
                        <OvVideoComponent user={localUser} mutedSound={true} />
                        <div className="littleNickName-portrait">
                          {localUser.getNickname()}
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.subscribers.map((sub, i) => (
                    <div key={i} className="pn-ProductNav_Link" style={{ opacity: this.state.mobileSelectVideo == sub? '1': '0.3'}}>
                      <div onClick={() => this.changeMobileSelectVideo(sub)}>
                        <OvVideoComponent user={sub} mutedSound={true} />
                        <div className="littleNickName-portrait">
                          {sub.getNickname()}
                        </div>
                      </div>
                    </div>
                  ))}

                </div>
              </nav>
            </div>
          ) : null}

          {this.props.embededMode != "true" && localUser !== undefined && isMobileOnly == false && localUser.getStreamManager() !== undefined && (
            <SidebarComponent
              ref = "Sidebar"
              userData = {this.props.userData}
              xPosition={this.state.xPositionChat}
              user={localUser}
              close={() => this.triggerCloseChat(this)}
              messageReceived={this.checkNotification}
            />
          )}

          {this.state.askLeaveSession !== false && (
            <Popup className={endPopupClassName} onClose={this.notLeaveSession} open={true} closeOnDocumentClick={true} closeOnEscape={false} modal position="right center">
              <div>
                <div className="title"><div className="titleText">Voulez-vous vraiment quitter le cours<br />en visio ?</div></div>
                <div className="bottom">
                  <button className="btn1" onClick={this.notLeaveSession}>
                    Annuler
                  </button>
                  <button className="btn2" onClick={this.leaveSession}>
                    Quitter le cours
                  </button>
                </div>
              </div>
            </Popup>
          )}

          {this.state.askRecordFile !== false && (
            <>
              {this.props.embededMode == "true" ? (
                <Popup className={recordPopupClassName} onClose={this.notRecordFile} open={true} closeOnDocumentClick={true} closeOnEscape={false} modal position="right center">
                  <div>
                    <div className="title"><div className="titleText">Utiliser cette enregistrement ?</div></div>
                    <div className="bottom">
                      <button className="btn2" onClick={this.embededRecordFile}>
                        Oui
                      </button>
                      <button className="btn1" onClick={this.notRecordFile}>
                        Non
                      </button>
                    </div>
                  </div>
                </Popup>
              ) : (
                <Popup className={recordPopupClassName} onClose={this.notRecordFile} open={true} closeOnDocumentClick={true} closeOnEscape={false} modal position="right center">
                  <div>
                    <div className="title"><div className="titleText">Enregistrer le fichier ?</div></div>
                    <div className="bottom">
                      <button className="btn2" onClick={this.downloadRecordFile}>
                        Oui
                      </button>
                      <button className="btn1" onClick={this.notRecordFile}>
                        Non
                      </button>
                    </div>
                  </div>
                </Popup>
              )}
            </>
          )}
        </div>
      );
    }

}
export default VideoRoomComponent;
